define([
	"dojo/_base/lang",
	"dojo/keys",
	"dojo/on",
	"csi",
	"csi/action",
	"csi/comm/GetRequest",
	"csi/def/Action",
	"csi/html",
	"csi/session",
	"csi/state",
	"csi/state/rootStore",
	"csi/xml",
	"src/c8-platform/core/request"
], function(lang, keys, on, csi, csiAction, GetRequest, Action, html, session, state, {routerStore, sessionStore}, xml, {REQUEST_MODULE, REQUEST_OPERATION, createFormData, postFormData}) {

	function _openWindow(actionName, param, value) {
		const map = {
			"AnalyzeDependencies": "dependency",
			"AnalyzeFanouts": "fan-outs",
			"AnalyzeLogs": "logs",
			"AnalyzeLoops": "loops",
			"ClassBrowser": "class-browser",
			"CustomerActions": "customer-actions",
			"DataCleanup": "cleanup",
			"DomainBrowser": "domain-browser",
			"ExpressionPage": "expression",
			"FileVault": "file-vault",
			"NodeBrowser": "node-browser",
			"OperationPage": "operation",
			"PerformanceMonitor": "performance",
			"RestAPI": "rest",
			"SearchPage": "search"
		};

		var file = map[actionName];
		var s = csi.url("tools/" + file + ".html") + (param ? "?" + param + "=" + value : "");
		csi.browserWindow(s, file);
	}

	on(document, "keydown", function(evt) {
		// summary: debug key mappings
		var element = state.get("lastActionElement");
		var view = state.get("lastActionView");

		if (evt.charCode != 0) {
			// alphabetic keys overlap with function key codes, so test for charCode of 0
			return;
		} else if (evt.keyCode == keys.F2) {
			// print out resources for view if F2 pressed
			if (view) {
				if (evt.ctrlKey || evt.metaKey) {
					csiAction.invoke(view, element, lang.mixin(new Action(), {
						m_id: "View Information",
						classController: "Debug/ViewInformation"
					}));
				} else {
					// show view XML for current view
					csiAction.invoke(view, element, lang.mixin(new Action(), {
						m_id: "View XML",
						classController: "Debug/ViewXml"
					}));
				}
			}
		} else if (evt.keyCode == keys.F8) {
			var url = html.getElementContext(element);

			if (view) {
				if (evt.ctrlKey || evt.metaKey) {
					const params = {
						logVersionPaths: true,
						useCurrentView: true,
					};

					csiAction.invoke(view, element, lang.mixin(new Action(), {
						m_id: "Check Custom View Paths",
						classController: "Debug/CustomViewCheck",
					}), params);
				} else if (xml.isValidURL(url)) {
					if (!evt.ctrlKey && !evt.metaKey) {
						_openWindow("NodeBrowser", "url", escape(url));
					}
				}
			}
		}
	});

	return {
		onActionExportProfiles: function(ac) {
			var request = new GetRequest("NodeProcessor", "ExportQuerySimple", {
				"Qry.Node.Type": "EQ_CS_ProfileSession",
				"Dep.Path": "Child:Actions/Child:Requests",
				OutputJSON: "0"
			});

			csi.browserWindow(request.toRequest(), "Profiles");
		},

		onActionCustomViewsForQueryAccelerator: function(ac) {
			var request = new GetRequest("CustomViews", "AnalyzeCustomViewsForReportService");

			csi.browserWindow(request.toRequest(), "Custom Views for Query Accelerator");
		},

		reinitializeForms() {
			const formData = createFormData({
				[REQUEST_MODULE]: "Form",
				[REQUEST_OPERATION]: "InitializeForms",
			});

			postFormData(formData);
		},

		onDebugPage: function(ac) {
			_openWindow(ac.m_action.m_id);
		},

		onNodePage: function(ac) {
			_openWindow(ac.m_action.m_id, "url", escape(routerStore.locationUrl));
		},

		onClassPage: function(ac) {
			_openWindow(ac.m_action.m_id, "class", routerStore.locationType);
		},

		onExprPage: function(ac) {
			_openWindow(ac.m_action.m_id, "url", escape(routerStore.locationUrl));
		},

		onDomainPage: function(ac) {
			_openWindow(ac.m_action.m_id, "class", routerStore.locationType);
		},

		onSearchPage: function(ac) {
			_openWindow(ac.m_action.m_id, "class", routerStore.locationType);
		},

		onRestApiPage: function(ac) {
			_openWindow(ac.m_action.m_id, "class", routerStore.locationType);
		},

		onHome: function(ac) {
			const {homeUrl} = sessionStore;
			const ref = session.getLocationForUrl(homeUrl);
			window.location = ref;
		}
	};
});